import { Box, Flex, Heading, Image, Text } from '@chakra-ui/react';
import React from 'react';
import { lineBreakToBr } from '../../../util';

import { responsiveValue } from '../../../assets/style/defaultTheme';

const { flexBoxDirection, participationContentBoxWidth } = responsiveValue;


type Props = {
  title?: string;
  data1: any;
  data2?: any;
};

function ParticipationContentItemImage({ title, data1, data2 }: Props) {

  return (
    <Flex justify="space-between" pt="3" pb="5" direction={flexBoxDirection}>
      <Heading size="2xl" color="b.bk" pb={{ base: "2", md: "0", lg: "0" }} textTransform="capitalize">{title}</Heading>
      <Box color="b.g" w={title ? participationContentBoxWidth : '100%'}>
        <Image src={data1.url} maxW="100%" w="100%" />
        {
          data2 && (
            <Text fontSize="md" color="b.lg" pt="4">{data2}</Text>
          )
        }
      </Box>
    </Flex>
  );
}

ParticipationContentItemImage.defaultProps = {
};

export default ParticipationContentItemImage;
